<template>
  <div class="components-container board">
    <div class="board-column">
      <div class="board-column-header" :style="{background:'#4A9FF9'}">
        To do
      </div>
      <draggable class="board-column-content" :list="to_do_list" group="project" v-bind="$attrs" @change="update_todo">
          <el-card class="board-item"
                   shadow="always"
                   v-for="(element) in to_do_list"
                   :key="element.id">
            <el-row>
              <el-tag>
                {{element.projectId}}
              </el-tag>
              <el-tag
                style="margin-left: 10px"
              >
                {{element.projectName}}
              </el-tag>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-tag type="success">Start Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.planStart"
                  type="date"
                  style="width:140px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-tag type="danger">Due Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.dueDate"
                  type="date"
                  style="width:140px; margin-left: 8px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <i class="el-icon-user"> PM</i>
                <el-tag type="warning" style="margin-left: 8px">
                  {{ element.pmName }}
                </el-tag>
              </el-col>
              <el-col :span="3">
                <el-tag :type="(element.status == 'To Do' ? 'warning' : (element.status == 'In Progress' ? 'success' : (element.status == 'Hold' ? 'danger' : (element.status == 'Complete' ? '' : ''))))" size="mini" effect="dark">
                  {{ element.status == 'To Do' ? 'To Do' : (element.status == 'In Progress' ? 'In Progress' : (element.status == 'Hold' ? 'Hold' : (element.status == 'Complete' ? 'Complete' : 'Complete'))) }}
                </el-tag>
              </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-alert
                            title="Risk"
                            :type="(element.risk == 'Normal' ? 'success' : (element.risk == 'Low' ? 'warning' : (element.risk == 'High' ? 'error' : (element.risk == 'Unknown' ? 'info' : ''))))"
                            :closable="false"
                            show-icon>
                        <template slot="title">
                            <div class="iconSize">Risk: {{element.risk}}</div>
                        </template>
                    </el-alert>
                </el-col>
            </el-row>
          </el-card>
      </draggable>
    </div>

    <div class="board-column">
      <div class="board-column-header" :style="{background:'#f9944a'}">
        Designing
      </div>
      <draggable class="board-column-content" :list="designing_list" group="project" @change="update_designing">
          <el-card class="board-item"
                 shadow="always"
                 v-for="(element) in designing_list"
                   :key="element.id">
            <el-row>
              <el-tag>
                {{element.projectId}}
              </el-tag>
              <el-tag
                style="margin-left: 10px"
              >
                {{element.projectName}}
              </el-tag>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-tag type="success">Start Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.planStart"
                  type="date"
                  style="width:140px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-tag type="danger">Due Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.dueDate"
                  type="date"
                  style="width:140px; margin-left: 8px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <i class="el-icon-user"> PM</i>
                <el-tag type="warning" style="margin-left: 8px">
                  {{ element.pmName }}
                </el-tag>
              </el-col>
              <el-col :span="3">
                <el-tag :type="(element.status == 'To Do' ? '' : (element.status == 'In Progress' ? 'success' : (element.status == 'Hold' ? 'danger' : (element.status == 'Complete' ? 'warning' : 'danger'))))" size="mini" effect="dark">
                  {{ element.status == 'To Do' ? 'To Do' : (element.status == 'In Progress' ? 'In Progress' : (element.status == 'Hold' ? 'Hold' : (element.status == 'Complete' ? 'Complete' : 'success'))) }}
                </el-tag>
              </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-alert
                            title="Risk"
                            :type="(element.risk == 'Normal' ? 'success' : (element.risk == 'Low' ? 'warning' : (element.risk == 'High' ? 'error' : (element.risk == 'Unknown' ? 'info' : ''))))"
                            :closable="false"
                            show-icon>
                        <template slot="title">
                            <div class="iconSize">Risk: {{element.risk}}</div>
                        </template>
                    </el-alert>
                </el-col>
            </el-row>
        </el-card>
      </draggable>
    </div>

    <div class="board-column">
      <div class="board-column-header" :style="{background:'#DAA520'}">
        Developing
      </div>
      <draggable class="board-column-content" v-model="developing_list" :list="developing_list" group="project" @change="update_developing">
          <el-card class="board-item"
                   v-for="(element) in developing_list"
                   :key="element.id">
            <el-row>
              <el-tag>
                {{element.projectId}}
              </el-tag>
              <el-tag
                style="margin-left: 10px"
              >
                {{element.projectName}}
              </el-tag>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-tag type="success">Start Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.planStart"
                  type="date"
                  style="width:140px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-tag type="danger">Due Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.dueDate"
                  type="date"
                  style="width:140px; margin-left: 8px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <i class="el-icon-user"> PM</i>
                <el-tag type="warning" style="margin-left: 8px">
                  {{ element.pmName }}
                </el-tag>
              </el-col>
              <el-col :span="3">
                <el-tag :type="(element.status == 'To Do' ? 'warning' : (element.status == 'In Progress' ? 'success' : (element.status == 'Hold' ? 'danger' : (element.status == 'Complete' ? '' : ''))))" size="mini" effect="dark">
                  {{ element.status == 'To Do' ? 'To Do' : (element.status == 'In Progress' ? 'In Progress' : (element.status == 'Hold' ? 'Hold' : (element.status == 'Complete' ? 'Complete' : 'Complete'))) }}
                </el-tag>
              </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-alert
                            title="Risk"
                            :type="(element.risk == 'Normal' ? 'success' : (element.risk == 'Low' ? 'warning' : (element.risk == 'High' ? 'error' : (element.risk == 'Unknown' ? 'info' : ''))))"
                            :closable="false"
                            show-icon>
                        <template slot="title">
                            <div class="iconSize">Risk: {{element.risk}}</div>
                        </template>
                    </el-alert>
                </el-col>
            </el-row>
          </el-card>
      </draggable>
    </div>

    <div class="board-column">
      <div class="board-column-header" :style="{background:'#DC143C'}">
        Testing
      </div>
      <draggable class="board-column-content" :list="testing_list" group="project" @change="update_testing">
            <el-card class="board-item"
                     v-for="(element) in testing_list"
                     :key="element.id">
              <el-row>
                <el-tag>
                  {{element.projectId}}
                </el-tag>
                <el-tag
                  style="margin-left: 10px"
                >
                  {{element.projectName}}
                </el-tag>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <el-tag type="success">Start Date</el-tag>
                </el-col>
                <el-col :span="3">
                  <el-date-picker
                    v-model="element.planStart"
                    type="date"
                    style="width:140px"
                    readonly
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="9">
                  <el-tag type="danger">Due Date</el-tag>
                </el-col>
                <el-col :span="3">
                  <el-date-picker
                    v-model="element.dueDate"
                    type="date"
                    style="width:140px; margin-left: 8px"
                    readonly
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <i class="el-icon-user"> PM</i>
                  <el-tag type="warning" style="margin-left: 8px">
                    {{ element.pmName }}
                  </el-tag>
                </el-col>
                <el-col :span="3">
                  <el-tag :type="(element.status == 'To Do' ? '' : (element.status == 'In Progress' ? 'success' : (element.status == 'Hold' ? 'danger' : (element.status == 'Complete' ? 'warning' : 'danger'))))" size="mini" effect="dark">
                    {{ element.status == 'To Do' ? 'To Do' : (element.status == 'In Progress' ? 'In Progress' : (element.status == 'Hold' ? 'Hold' : (element.status == 'Complete' ? 'Complete' : 'success'))) }}
                  </el-tag>
                </el-col>
              </el-row>
              <el-row>
                  <el-col>
                      <el-alert
                              title="Risk"
                              :type="(element.risk == 'Normal' ? 'success' : (element.risk == 'Low' ? 'warning' : (element.risk == 'High' ? 'error' : (element.risk == 'Unknown' ? 'info' : ''))))"
                              :closable="false"
                              show-icon>
                          <template slot="title">
                              <div class="iconSize">Risk: {{element.risk}}</div>
                          </template>
                      </el-alert>
                  </el-col>
              </el-row>
            </el-card>
      </draggable>
    </div>

    <div class="board-column">
      <div class="board-column-header" :style="{background:'#C71585'}">
        Debug/Bug fixing
      </div>
      <draggable class="board-column-content" :list="bugfix_list" group="project" @change="update_debug">
          <el-card class="board-item"
                   v-for="(element) in bugfix_list"
                   :key="element.id">
            <el-row>
              <el-tag>
                {{element.projectId}}
              </el-tag>
              <el-tag
                style="margin-left: 10px"
              >
                {{element.projectName}}
              </el-tag>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-tag type="success">Start Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.planStart"
                  type="date"
                  style="width:140px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-tag type="danger">Due Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.dueDate"
                  type="date"
                  style="width:140px; margin-left: 8px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <i class="el-icon-user"> PM</i>
                <el-tag type="warning" style="margin-left: 8px">
                  {{ element.pmName }}
                </el-tag>
              </el-col>
              <el-col :span="3">
                <el-tag :type="(element.status == 'To Do' ? 'warning' : (element.status == 'In Progress' ? 'success' : (element.status == 'Hold' ? 'danger' : (element.status == 'Complete' ? '' : ''))))" size="mini" effect="dark">
                  {{ element.status == 'To Do' ? 'To Do' : (element.status == 'In Progress' ? 'In Progress' : (element.status == 'Hold' ? 'Hold' : (element.status == 'Complete' ? 'Complete' : 'Complete'))) }}
                </el-tag>
              </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-alert
                            title="Risk"
                            :type="(element.risk == 'Normal' ? 'success' : (element.risk == 'Low' ? 'warning' : (element.risk == 'High' ? 'error' : (element.risk == 'Unknown' ? 'info' : ''))))"
                            :closable="false"
                            show-icon>
                        <template slot="title">
                            <div class="iconSize">Risk: {{element.risk}}</div>
                        </template>
                    </el-alert>
                </el-col>
            </el-row>
          </el-card>
      </draggable>
    </div>

    <div class="board-column">
      <div class="board-column-header" :style="{background:'#228B22'}">
        Releasing
      </div>
      <draggable class="board-column-content" :list="releasing_list" group="project" @change="update_releasing">
          <el-card class="board-item"
                   v-for="(element) in releasing_list"
                   :key="element.id">
            <el-row>
              <el-tag>
                {{element.projectId}}
              </el-tag>
              <el-tag
                style="margin-left: 10px"
              >
                {{element.projectName}}
              </el-tag>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-tag type="success">Start Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.planStart"
                  type="date"
                  style="width:140px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-tag type="danger">Due Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.dueDate"
                  type="date"
                  style="width:140px; margin-left: 8px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <i class="el-icon-user"> PM</i>
                <el-tag type="warning" style="margin-left: 8px">
                  {{ element.pmName }}
                </el-tag>
              </el-col>
              <el-col :span="3">
                <el-tag :type="(element.status == 'To Do' ? 'warning' : (element.status == 'In Progress' ? 'success' : (element.status == 'Hold' ? 'danger' : (element.status == 'Complete' ? '' : ''))))" size="mini" effect="dark">
                  {{ element.status == 'To Do' ? 'To Do' : (element.status == 'In Progress' ? 'In Progress' : (element.status == 'Hold' ? 'Hold' : (element.status == 'Complete' ? 'Complete' : 'Complete'))) }}
                </el-tag>
              </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-alert
                            title="Risk"
                            :type="(element.risk == 'Normal' ? 'success' : (element.risk == 'Low' ? 'warning' : (element.risk == 'High' ? 'error' : (element.risk == 'Unknown' ? 'info' : ''))))"
                            :closable="false"
                            show-icon>
                        <template slot="title">
                            <div class="iconSize">Risk: {{element.risk}}</div>
                        </template>
                    </el-alert>
                </el-col>
            </el-row>
          </el-card>
      </draggable>
    </div>

    <div class="board-column">
      <div class="board-column-header" :style="{background:'#556B2F'}">
        Archive
      </div>
      <draggable class="board-column-content" :list="archive_list" group="project" @change="update_archive">
          <el-card class="board-item"
                   v-for="(element) in archive_list"
                   :key="element.id">
            <el-row>
              <el-tag>
                {{element.projectId}}
              </el-tag>
              <el-tag
                style="margin-left: 10px"
              >
                {{element.projectName}}
              </el-tag>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-tag type="success">Start Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.planStart"
                  type="date"
                  style="width:140px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-tag type="danger">Due Date</el-tag>
              </el-col>
              <el-col :span="3">
                <el-date-picker
                  v-model="element.dueDate"
                  type="date"
                  style="width:140px; margin-left: 8px"
                  readonly
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <i class="el-icon-user"> PM</i>
                <el-tag type="warning" style="margin-left: 8px">
                  {{ element.pmName }}
                </el-tag>
              </el-col>
              <el-col :span="3">
                <el-tag :type="(element.status == 'To Do' ? 'warning' : (element.status == 'In Progress' ? 'success' : (element.status == 'Hold' ? 'danger' : (element.status == 'Complete' ? '' : ''))))" size="mini" effect="dark">
                  {{ element.status == 'To Do' ? 'To Do' : (element.status == 'In Progress' ? 'In Progress' : (element.status == 'Hold' ? 'Hold' : (element.status == 'Complete' ? 'Complete' : 'Complete'))) }}
                </el-tag>
              </el-col>
            </el-row>
          </el-card>
      </draggable>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import projectApi from "@/api/project";

export default {
  name: "projectKanban",
  order: 1,
  components: {
    draggable
  },
  data() {
    return {
      to_do_list:[],
      designing_list:[],
      developing_list:[],
      testing_list:[],
      bugfix_list:[],
      releasing_list:[],
      archive_list:[],
    };
  },
  methods: {
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function(evt) {
      window.console.log(evt);
    },

    add(evt) {
      console.log("新增", evt);
    },
    end(evt) {
      console.log("结束", evt);
    },
    update(evt) {
      window.console.log("更新", evt);
    },
    d_statusList:['To Do','Designing','Developing','Testing','Debug/Bug fixing','Releasing','Archive'],

    async update_todo(evt) {
      let payload = {}
      payload['d_status'] = "To Do"
      let para = {id: evt['added']['element']['id']}
      await projectApi.editProjectKanban(para, payload).then()
      this.getToDoList()
    },

    async update_designing(evt) {
      let payload = {}
      payload['d_status'] = "Designing"
      let para = {id: evt['added']['element']['id']}
      await projectApi.editProjectKanban(para, payload).then()
      // this.loading = false
      this.getDesigningList()
    },
    async update_developing(evt) {
      let payload = {}
      payload['d_status'] = "Developing"
      console.log(evt['added']['element']['id'])
      let para = {id: evt['added']['element']['id']}
      await projectApi.editProjectKanban(para, payload).then()
      //this.loading = false
      this.getDevelopingList()
    },
    async update_testing(evt) {
      let payload = {}
      payload['d_status'] = "Testing"
      console.log(evt['added']['element']['id'])
      let para = {id: evt['added']['element']['id']}
      await projectApi.editProjectKanban(para, payload).then()
      //this.loading = false
      this.getTestingList()
    },
    async update_debug(evt) {
      let payload = {}
      payload['d_status'] = "Debug/Bug fixing"
      console.log(evt['added']['element']['id'])
      let para = {id: evt['added']['element']['id']}
      await projectApi.editProjectKanban(para, payload).then()
      //this.loading = false
      this.getBugfixList()
    },
    async update_releasing(evt) {
      let payload = {}
      payload['d_status'] = "Releasing"
      console.log(evt['added']['element']['id'])
      let para = {id: evt['added']['element']['id']}
      await projectApi.editProjectKanban(para, payload).then()
      //this.loading = false
      this.getReleasingList()
    },
    async update_archive(evt) {
      let payload = {}
      payload['d_status'] = "Archive"
      console.log(evt['added']['element']['id'])
      let para = {id: evt['added']['element']['id']}
      await projectApi.editProjectKanban(para, payload).then()
      //this.loading = false
      this.getArchiveList()
    },


 /*   transferProject(element){
      let para = { id:  project_id}
      payload['d_status'] = element.id
      projectApi.editProject(para, payload).then()
    },*/

    getToDoList(){
      let para = {}
      para['d_status'] = 'To Do'
      projectApi.getKanban(para).then(
        res => {
          this.to_do_list = res.data.data
        }
      )
    },
    getDesigningList(){
      let para = {}
      para['d_status'] = 'Designing'
      projectApi.getKanban(para).then(
        res => {
          this.designing_list = res.data.data
        }
      )
    },
    getDevelopingList(){
      let para = {}
      para['d_status'] = 'Developing'
      projectApi.getKanban(para).then(
        res => {
          this.developing_list = res.data.data
        }
      )
    },
    getTestingList(){
      let para = {}
      para['d_status'] = 'Testing'
      projectApi.getKanban(para).then(
        res => {
          this.testing_list = res.data.data
        }
      )
    },
    getBugfixList(){
      let para = {}
      para['d_status'] = 'Debug/Bug fixing'
      projectApi.getKanban(para).then(
        res => {
          this.bugfix_list = res.data.data
        }
      )
    },
    getReleasingList(){
      let para = {}
      para['d_status'] = 'Releasing'
      projectApi.getKanban(para).then(
        res => {
          this.releasing_list = res.data.data
        }
      )
    },
    getArchiveList(){
      let para = {}
      para['d_status'] = 'Archive'
      projectApi.getKanban(para).then(
        res => {
          this.archive_list = res.data.data
        }
      )
    },
    getAllList(){
      this.getToDoList()
      this.getDesigningList()
      this.getDevelopingList()
      this.getTestingList()
      this.getBugfixList()
      this.getReleasingList()
      this.getArchiveList()
    }
  },
  mounted(){
    this.getAllList()
  },
};
</script>

<style lang="scss" scoped>
.board {
  width: 2100px;
  margin-left: 40px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: flex-start;
}
.board-column {
  min-width: 200px;
  min-height: 100px;
  height: auto;
  overflow: hidden;
  background: #f0f0f0;
  border-radius: 3px;

  .board-column-header {
    height: 50px;
    line-height: 50px;
    overflow: hidden;
    padding: 0 20px;
    text-align: center;
    color: #fff;
    border-radius: 3px 3px 0 0;
  }

  .board-column-content {
    height: auto;
    overflow: hidden;
    border: 10px solid transparent;
    min-height: 60px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;

    .board-item {
      cursor: pointer;
      width: 100%;
      height: 265px;
      margin: 3px;
      background-color: #fff;
      text-align: left;
      line-height: 42px;
      padding:0 10px;
      box-sizing: border-box;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    }
    .item {
      margin-top: 10px;
      margin-right: 40px;
    }
    .iconSize{
      font-size: 13px;
      padding: 10px;
      font-weight: bold;
      height: 35px;

    }
  }
}
</style>
